export const skills = {
  Frontend: ['React.js', 'Next.js', 'JavaScript ES6+', 'TypeScript', 'jQuery', 'Bootstrap', 'Tailwind CSS'],
  Backend: ['Node.js', 'Express.js', 'REST APIs', 'Mongoose', 'WordPress'],
  Databases: ['MongoDB', 'MySQL'],
  'Tools & Cloud': ['Git', 'GitHub', 'Docker', 'AWS', 'DigitalOcean'],
};

export const projects = [
  {
    id: 1,
    name: 'Edidact Learning Platform',
    category: 'EdTech · React.js',
    year: '2023',
    color: '#0ea5e9',
    gradient: 'linear-gradient(135deg, rgba(14,165,233,0.15), rgba(56,189,248,0.05))',
    desc: 'Interactive K-12 platform enabling teachers and parents to create, share, and assign exercises across all school subjects.',
    tags: ['React.js', 'Node.js', 'MongoDB', 'REST API'],
    icon: '📚',
    type: 'Freelance · Switzerland',
    highlights: [
      'Reusable component library',
      'Multi-role auth (teacher / parent / student)',
      'Subject-based content engine',
    ],
  },
  {
    id: 2,
    name: 'Employee Medical Wellness App',
    category: 'HealthTech · React.js',
    year: '2021',
    color: '#34d399',
    gradient: 'linear-gradient(135deg, rgba(52,211,153,0.12), rgba(16,185,129,0.04))',
    desc: 'Corporate health management application for employee wellness tracking, adopted across multiple B2B clients.',
    tags: ['React.js', 'Node.js', 'MongoDB', 'Express'],
    icon: '🏥',
    type: 'Contract · Paris, France',
    highlights: [
      'B2B multi-tenant architecture',
      'Employee health dashboards',
      'Deployed for multiple corporates',
    ],
  },
  {
    id: 3,
    name: 'IBM Maximo IoT Dashboards',
    category: 'Enterprise IoT · Full-Stack',
    year: '2020',
    color: '#818cf8',
    gradient: 'linear-gradient(135deg, rgba(129,140,248,0.14), rgba(99,102,241,0.04))',
    desc: 'Enterprise asset management with real-time IoT dashboards and Maximo Mobile-ready interfaces for industrial field technicians.',
    tags: ['IBM Maximo', 'IoT', 'Node.js', 'Mobile'],
    icon: '⚙️',
    type: 'Full-Time · Sousse, Tunisia',
    highlights: [
      'Real-time asset monitoring',
      'Mobile-ready field interface',
      'IBM Premier Partner project',
    ],
  },
  {
    id: 4,
    name: 'Classified Ads Platform',
    category: 'Marketplace · Frontend',
    year: '2018',
    color: '#f59e0b',
    gradient: 'linear-gradient(135deg, rgba(245,158,11,0.12), rgba(251,191,36,0.04))',
    desc: 'Full classified ads web application with responsive design serving hundreds of daily active users, including a custom web scraper.',
    tags: ['JavaScript', 'HTML/CSS', 'Web Scraping', 'Bootstrap'],
    icon: '🛒',
    type: 'Full-Time · Sousse, Tunisia',
    highlights: [
      'Hundreds of daily active users',
      'Custom web scraper built',
      'Fully responsive UX',
    ],
  },
  {
    id: 5,
    name: 'Mbakop SaaS Products',
    category: 'Full-Stack · Node + React',
    year: '2020–2025',
    color: '#38bdf8',
    gradient: 'linear-gradient(135deg, rgba(56,189,248,0.12), rgba(14,165,233,0.04))',
    desc: '4.5 years delivering 10+ production projects — REST APIs, React SPAs, and WordPress sites for a US-based product company.',
    tags: ['Node.js', 'React.js', 'MongoDB', 'WordPress'],
    icon: '🚀',
    type: 'Remote · Atlanta, USA',
    highlights: [
      '10+ production projects shipped',
      'REST APIs at scale',
      'React SPAs + WordPress',
    ],
  },
  {
    id: 6,
    name: 'Next IT Era — Agency',
    category: 'Startup · Digital Agency',
    year: '2025',
    color: '#f472b6',
    gradient: 'linear-gradient(135deg, rgba(244,114,182,0.12), rgba(236,72,153,0.04))',
    desc: 'Founded and scaled a full-service digital agency offering end-to-end product development, cloud integration, and digital transformation.',
    tags: ['Full-Stack', 'AWS', 'DigitalOcean', 'Strategy'],
    icon: '🏢',
    type: 'Founder · Dubai, UAE',
    highlights: [
      'International client base',
      'End-to-end product delivery',
      'Cloud & DevOps integration',
    ],
  },
];

export const experience = [
  {
    title: 'Founder & CEO',
    company: 'Next IT Era',
    period: 'Apr 2025 – Present',
    location: 'Dubai, UAE',
    desc: 'Founded a full-service digital agency delivering full-stack development, cloud integration, and product strategy to international clients across Europe, MENA, and beyond.',
  },
  {
    title: 'Full-Stack Developer',
    company: 'Mbakop LLC',
    period: 'Aug 2020 – Apr 2025',
    location: 'Atlanta, USA · Remote',
    desc: '4.5 years delivering Node.js/MongoDB backends, React SPAs, and WordPress solutions for US-based clients. 10+ production projects shipped.',
  },
  {
    title: 'React Developer',
    company: 'Edidact',
    period: 'May 2023 – Jan 2024',
    location: 'Switzerland · Remote',
    desc: 'Built an interactive K-12 learning platform in React for teachers and parents, with a reusable component library.',
  },
  {
    title: 'Full-Stack Developer',
    company: 'Predict Analyse',
    period: 'Jan 2021 – Dec 2022',
    location: 'Paris, France · Remote',
    desc: 'Delivered a medical employee wellness app and corporate website in React.js, plus a WordPress blog.',
  },
  {
    title: 'Full-Stack Developer',
    company: 'IMaxeam – IBM Premier Partner',
    period: 'Aug 2019 – Aug 2020',
    location: 'Sousse, Tunisia',
    desc: 'IBM Maximo IoT dashboards and mobile-ready enterprise asset management solutions for industrial clients.',
  },
  {
    title: 'Project Manager',
    company: 'Songocom Agency',
    period: 'Jan 2019 – Aug 2019',
    location: 'Sousse, Tunisia',
    desc: 'Led web/mobile project portfolio, tech platform strategy, and external partnerships.',
  },
  {
    title: 'Frontend Developer',
    company: 'Visacom',
    period: 'Mar 2018 – Jul 2019',
    location: 'Sousse, Tunisia',
    desc: 'Built a classified ads platform, engineered a web scraper, and managed app development delivery.',
  },
];
